module.exports = __webpack_public_path__ + "static/media/eduTechImg1.2b2b9f46.webp";